// app/javascript/components/GroupChannelPage.jsx

import React from "react";
import GroupChannel from "@sendbird/uikit-react/GroupChannel";
import CustomMessageContent from "./CustomMessageContent";
import CustomMessageInput from "./CustomMessageInput";


export default function GroupChannelPage(props) {
    const {channelUrl, conversationId} = props;

    return (
        <GroupChannel
            channelUrl={channelUrl}
            isReactionEnabled={false}
            disableUserProfile={true}
            replyType="NONE"
            renderChannelHeader={() => null}
            renderMessageContent={(messageProps) => (
                <CustomMessageContent
                    {...messageProps}
                    conversationId={conversationId}
                />
            )}
            renderMessageInput={() => (
                <CustomMessageInput
                    conversationId={conversationId}
                    fallbackMode={false}
                />
            )}
        />
    );
}
